import {
	GeneralDocument,
	generalDocumentQuery,
	type ResolvedDoc,
} from '#app/components/general-document.tsx'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/rules.ts'

export async function loader() {
	// In Sanity Studio, set the Name field to "rules" for this document
	const doc = await safeFetch<ResolvedDoc | null>(
		`*[_type == "generalDocument" && name == "rules"][0] ${generalDocumentQuery}`,
	)
	return { doc }
}

export default function TournamentRules({ loaderData }: Route.ComponentProps) {
	return <GeneralDocument doc={loaderData.doc} />
}
